import * as z from "zod";

import {
  partnerIdSchema,
  partnerUserSchema,
  partnerUserStatusSchema,
} from "./shared";

export const updatePartnerUserStatus = {
  name: "updatePartnerUserStatus" as const,
  input: z.object({
    partnerId: partnerIdSchema,
    partnerUserId: partnerIdSchema,
    status: partnerUserStatusSchema,
  }),
  output: z.object({ user: partnerUserSchema }),
};
